import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from "@angular/core";
import { Compbaser } from "../../../../components/compbaser";
import { StoreSelectorsService } from "../../../../services";
import { Id } from "../../../../interfaces";
import { actionSetEditorMode } from "../../../../store/actions/user.actions";
import { DialogPreviewData } from "../../../../components/dialog-preview/dialog-preview.component";

@Component({
    selector: "app-slideer-item",
    templateUrl: "./touch-item.component.html",
    styleUrls: ["./touch-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TouchItemComponent extends Compbaser implements OnInit, OnChanges {
    width = 1920;
    height = 1080;
    slideWidth = 1920;
    slideThumbWidth = 140;
    slideThumbHeight;
    slideSubSceneData = null;
    updating = false;
    editingSlideSceneId: string;

    @Input() isThumb = false;
    @Input() isPreview = true;
    @Input() updated = false;
    @Input() refresh = 0;
    @Input() sceneId: Id = "";
    @Output() previewRequested = new EventEmitter<void>();
    @Output() touchAction = new EventEmitter<void>();

    constructor(private storeSelector: StoreSelectorsService, private cdr: ChangeDetectorRef) {
        super();
        this.slideThumbHeight = (this.slideThumbWidth / this.width) * this.height;
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.listenSelectedSceneId().subscribe((sceneId) => {
                if (!sceneId) return;
                this.editingSlideSceneId = sceneId;
            }),
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["isPreview"]) {
            if (!this.isPreview && !this.isThumb) {
                this.getSlideSubSceneData();
            }
        }

        // Handle heavy refresh (component destruction/recreation)
        if (changes.refresh && !changes.refresh.isFirstChange()) {
            this.forceRefresh();
        }

        // temporarily comment out. But may use later. Don't remove codes
        if (changes.updated && !changes.updated.isFirstChange() && this.sceneId === this.editingSlideSceneId && this.isThumb) {
            this.updating = true;
            setTimeout(() => {
                this.updating = false;
                this.cdr.markForCheck();
            });
        }
    }

    private forceRefresh() {
        if (!this.slideSubSceneData) return;
        
        const currentData = this.slideSubSceneData;
        this.updating = true;
        this.slideSubSceneData = null; // Force destroy app-scene-builder
        this.cdr.detectChanges();

        setTimeout(() => {
            this.slideSubSceneData = currentData;
            this.updating = false;
            this.cdr.markForCheck();
        }, 100);
    }

    getSlideSubSceneData() {
        this.slideSubSceneData = null;
        setTimeout(() => {
            this.cod(
                this.storeSelector.listenSceneData(this.sceneId).subscribe((sceneData) => {
                    if (sceneData) {
                        this.slideSubSceneData = sceneData;
                        this.cdr.markForCheck();
                    }
                }),
            );
        });
    }

    onPlayPreviewEvent(e: DialogPreviewData) {
        this.previewRequested.emit();
    }

    onSceneLoaded(sceneId) {
        this.updating = false;
        this.cdr.detectChanges();
    }

    onTouchAction(e) {
        this.touchAction.emit(e);
    }

    override destroy() {
        // this.slideSubSceneData = null;
    }
}
